import React, { useState, useEffect } from 'react';
import StorageManager from '../context/StorageManager';
import Swal from 'sweetalert2';
import { Modal, Form, Alert, InputGroup, Card, Spinner, Button, Tab, Nav, Row, Col } from 'react-bootstrap';
import { useProvider, Toast } from '../context/MenuProvider';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import Markdown from '../components/Utils/Markdown';
import dayjs from "dayjs";
import RenderizarItem from '../components/Utils/RenderizarProduto';
import "dayjs/locale/pt-br";

dayjs.locale("pt-br");

const ProspectosBase = () => {
  const { hasPerms } = useProvider();
  const { fase } = useParams(); 
  const navigate = useNavigate();

  // Monta os itens com base nas permissões
  const navItems = [
    hasPerms(['leads']) && {
      key: "contatos",
      icon: "bx bx-group",
      label: "Contatos",
      component: <Contatos />
    },
    hasPerms(['leads']) && {
      key: "apresentar",
      icon: "bx bx-book-reader",
      label: "Apresentar",
      component: <Prospectos fase={`apresentar`} />
    },
    hasPerms(['leads']) && {
      key: "acompanhar",
      icon: "bx bxl-audible",
      label: "Acompanhar",
      component: <Prospectos fase={`acompanhar`} />
    },
    hasPerms(['leads']) && {
      key: "finalizado",
      icon: "bx bx-message-square-check",
      label: "Finalizado",
      component: <Prospectos fase={`finalizado`} />
    },
    hasPerms(['leads']) && {
      key: "esquecer",
      icon: "bx bx-message-square-x",
      label: "Esquecer",
      component: <Prospectos fase={`esquecer`} />
    }
  ].filter(Boolean);

  return (
    <>
      <Tab.Container
        id="details-tabs"
        activeKey={fase || `contatos`}
        onSelect={(k) => navigate(`/rede/prospectos/${k}/`, {replace:true})}
        mountOnEnter
        unmountOnExit
      >
        {/* Só renderiza se houver mais de 1 item */}
        {navItems.length > 1 && (
          <Nav variant="tabs" className="d-flex flex-nowrap overflow-auto">
            {navItems.map(item => (
              <Nav.Item key={item.key}>
                <Nav.Link eventKey={item.key} className="text-center">
                  <i className={`${item.icon} fs-1 text-dark`}></i>
                  <div className="small text-muted">{item.label}</div>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        )}

        <Tab.Content>
          {navItems.map(item => (
            <Tab.Pane key={item.key} eventKey={item.key}>
              {item.component}
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

const ProspectoItem = ({ prospecto, carregarAcompanhamentos }) => {
  const navigate = useNavigate();
  const [expandido, setExpandido] = useState(false);
  const [acompanhar, setAcompanhar] = useState(false);
  const [acompanhamentos, setAcompanhamentos] = useState([]);
  const [nextDownUrl, setNextDownUrl] = useState(null);
  const [loadingAcompanhamentos, setLoadingAcompanhamentos] = useState(false);
  const [dados, setDados] = useState(prospecto);
  const [loadingMais, setLoadingMais] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { crudAdmin } = useProvider();
  const { patch, post } = crudAdmin || {};

  const toggleSelecionar = async () => {
    try {
      const result = await Swal.fire({
        title: "Selecionar para apresentar?",
        text: `Selecionar ${dados?.nome} para apresentar a oportunidade de negócio?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        const response = await post(
          { 
            contato: dados?.id,
            observacoes:`Selecionado para apresentar o plano de negócios`,
          },
          `/rede/prospectos/`,
          null,
          "salvar"
        );
        if (response && response.length) {
          navigate(`/rede/prospectos/apresentar`);
          Toast.fire({ icon: "success", title: "Selecionado com sucesso" });
        }
      }
    } catch (err) {
      console.error("Erro ao ativar prospecto:", err);
    }
  };
  const toggleEsquecerCadastro = async () => {
    try {
      const result = await Swal.fire({
        title: `Mover para sessão "Esquecer" este Contato?`,
        text: `${dados?.cadastro?`Ao mover ${dados.nome} para sessão "Esquecer", o cadastro dele também será excluido do mapa de rede.`:`Você pode repuperar posteriormente ${dados.nome} na sessão "Esquecer"`}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        const response = await patch(
          { 
            fase: 'esquecer',
            observacoes:`Contato movido para sessão "Esquecer".`,
          },
          `/rede/prospectos/${dados?.id}/`,
          null,
          "salvar"
        );
        if (response && response.length) {
          navigate(`/rede/prospectos/esquecer`);
          Toast.fire({ icon: "success", title: "Movido com sucesso" });
        }
      }
    } catch (err) {
      console.error("Erro ao ativar prospecto:", err);
    }
  };
  const toggleAcompanharCadastro = async () => {
    try {
      const result = await Swal.fire({
        title: `Mover para sessão "Acompanhar" este Contato?`,
        text: `Ao mover ${dados.nome} para sessão "Acompanhar", ele entra no funil de acompanhamento.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        const response = await patch(
          { 
            fase: 'acompanhar',
            observacoes:`Contato movido para sessão "Acompanhar".`,
          },
          `/rede/prospectos/${dados?.id}/`,
          null,
          "salvar"
        );
        if (response && response.length) {
          navigate(`/rede/prospectos/acompanhar`);
          Toast.fire({ icon: "success", title: "Movido com sucesso" });
        }
      }
    } catch (err) {
      console.error("Erro ao ativar prospecto:", err);
    }
  };

  const toggleExpandAcompanhar = async () => {
    setShowModal(true);
  };
  
  const toggleExpand = async () => {
    if (!expandido && acompanhamentos.length === 0 && typeof carregarAcompanhamentos === "function") {
      setLoadingAcompanhamentos(true);
      const { results, next } = await carregarAcompanhamentos(dados.id);
      setAcompanhamentos(results);
      setNextDownUrl(next);
      setLoadingAcompanhamentos(false);
    }
    setExpandido(!expandido);
  };

  const carregarMais = async () => {
    if (!nextDownUrl || loadingMais) return;
    setLoadingMais(true);
    const { results, next } = await carregarAcompanhamentos(dados.id, nextDownUrl);
    setAcompanhamentos((prev) => [...prev, ...results]);
    setNextDownUrl(next);
    setLoadingMais(false);
  };
  
  
  const toggleCheckCadastro = async () => {
    if(dados.cadastro){
      navigate(`/rede/equipe/${dados.cadastro?.id || dados.cadastro}/editar/prospectos/`);
    } else {
      navigate(`/rede/equipe/novo/${dados?.id}/prospectos/`);
    }
  };
  
  const handleWhatsApp = async () => {
    const whats = (dados?.telefone || dados?.contato?.telefone)?.replace(/\D/g, '');
    if(!whats) return;
    const mensagem = encodeURIComponent(`Oi ${(dados?.nome || dados?.nome || dados?.contato?.nome)?.trim().split(' ')[0]}`);
    const url = `whatsapp://send?phone=+55${whats}&text=${mensagem}`;
    window.open(url);
  };

  return (<>
    <ModalAcompanhar
      show={showModal}
      onHide={() => setShowModal(false)}
      prospecto={dados}
      setDados={setDados}
      setAcompanhamentos={setAcompanhamentos}
    />
    <RenderizarItem
      col="d-none"
      lm="mb-1"
      text1={dayjs(dados?.data_evento||dados?.data_criacao).format("DD/MM/YYYY dddd")}
      titulo={`${dados?.nome}`}
      text2={(<>
        <Markdown texto={dados?.observacoes}></Markdown>
        <Row>
          <Col>
            {(expandido && ((dados.fase !== 'finalizado' && dados.fase !== 'esquecer') || (dados.fase === 'finalizado' && !dados.cadastro))) && (<>
              <Button variant="outline-danger" size="sm" className="ms-1" onClick={toggleEsquecerCadastro}>
                <i className="bx bx-trash"></i> Esquecer Contato
              </Button>
            </>)}
            {dados.fase === "esquecer" && (<>
              <Button variant="outline-success" size="sm" className="ms-1" onClick={toggleAcompanharCadastro}>
                <i className="bx bx-check-circle"></i> Restaurar Contato
              </Button>
            </>)}
            {(!expandido && dados?.contato) && (<>
              {dados.fase !== "esquecer" && (<>
                {!(dados.cadastro && dados.fase === "finalizado") && (
                  <Button variant="outline-secondary" size="sm" className="ms-1" onClick={()=>navigate(`/rede/apn/novo/${dados?.id}/prospectos/`)}>
                    <i className="bx bx-plus-circle"></i> Apn
                  </Button>
                )}
                <Button variant="outline-secondary" size="sm" className="ms-1" onClick={toggleCheckCadastro}>
                  <i className={`bx bx-${dados.cadastro?'check-circle':'plus-circle'}`}></i>{(dados.fase === "acompanhar" && dados.cadastro) && ("Pré-")}Cadastro
                </Button>
              </>)}
            </>)}
          </Col>
          <Col xs="auto">
            {(dados?.telefone || dados?.contato?.telefone) && (<Button onClick={handleWhatsApp} variant="outline-success" size="sm" className="ms-1"><i className="bx bxl-whatsapp"></i></Button>)}
            {!dados?.contato && (<>
              <Button variant="outline-secondary" size="sm" className="ms-1" onClick={toggleSelecionar}>
                <i className="bx bx-check-circle"></i> Selecionar
              </Button>
            </>)}
            <Button variant="outline-secondary" size="sm" className="ms-1" onClick={toggleExpandAcompanhar}>
              <i className="bx bx-edit"></i>
            </Button>
            {dados?.contato && (<>
              <Button variant="outline-secondary" size="sm" className="ms-1" onClick={toggleExpand}>
                {expandido ? <i className="bx bx-chevron-up"></i> : <i className="bx bx-chevron-down"></i>}
              </Button>
            </>)}
          </Col>
          {expandido && (
            <Col xs={12}>
              {loadingAcompanhamentos && <div className="text-center"><Spinner animation="border" size="sm" /></div>}
              {acompanhamentos.map((x) => (
                <div className="mt-1 pt-1 border-top ps-1" style={{ borderLeft: "2px solid lightgray" }}>
                  <div className="small text-muted">
                    Em {dayjs(x?.data).format("DD/MM/YYYY dddd")}
                  </div>
                  <Markdown texto={x?.observacoes}></Markdown>
                </div>
              ))}
              {nextDownUrl && (
                <div className="mt-2 text-center">
                  <Button variant="outline-secondary" size="sm" onClick={carregarMais} disabled={loadingMais}>
                    {loadingMais ? "Carregando..." : "Carregar mais"}
                  </Button>
                </div>
              )}
            </Col>
          )}
        </Row>
      </>)}
    />
  </>);
};

const Prospectos = ({fase}) => {
  const [query, setQuery] = useState('');
  const [prospectos, setProspectos] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const { setLinks, setBtns, crudAdmin } = useProvider();
  const { get, loading } = crudAdmin || {};
  const navigate = useNavigate();

  useEffect(() => {
    buscarProspectos(true);
  }, [query]);

  const buscarProspectos = async (novaConaulta = false, url = `/rede/prospectos/?fase=${fase}${query?`&search=${query}`:'&ordering=-data_evento,contato__nome'}`) => {
    try {
      const response = await get(url, "prospeccao");
      if (response && response[0]?.results) {
        setProspectos((prev) => novaConaulta ? [...response[0].results] : [...prev, ...response[0].results]);
        setNextUrl(response[0]?.next || null);
      } else {
        setProspectos([]);
        setNextUrl(null);
      }
    } catch (err) {
      console.error("Erro ao buscar prospectos:", err);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading && nextUrl) buscarProspectos(false, nextUrl);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, nextUrl]);


  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true, mirror: false });
  }, []);

  const carregarAcompanhamentos = async (contatoId, url = null) => {
    try {
      const finalUrl = url || `/rede/acompanhamentos/?ordering=-data&prospecto=${contatoId}&limit=3`;
      const response = await get(finalUrl, "pagina");
      if (response && response[0]?.results) {
        return { results: response[0].results, next: response[0].next };
      }
      return { results: [], next: null };
    } catch (err) {
      console.error("Erro ao buscar acompanhamentos:", err);
      return { results: [], next: null };
    }
  };
  const carregarApns = async (contatoId, url = null) => {
    try {
      const finalUrl = url || `/rede/apn/?ordering=-data&prospecto=${contatoId}&limit=3`;
      const response = await get(finalUrl, "pagina");
      if (response && response[0]?.results) {
        return { results: response[0].results, next: response[0].next };
      }
      return { results: [], next: null };
    } catch (err) {
      console.error("Erro ao buscar apns:", err);
      return { results: [], next: null };
    }
  };
  const carregarCadastros = async (contatoId, url = null) => {
    try {
      const finalUrl = url || `/rede/consultores/?ordering=-data_de_cadastro&prospecto=${contatoId}&limit=3`;
      const response = await get(finalUrl, "pagina");
      if (response && response[0]?.results) {
        return { results: response[0].results, next: response[0].next };
      }
      return { results: [], next: null };
    } catch (err) {
      console.error("Erro ao buscar apns:", err);
      return { results: [], next: null };
    }
  };

  useEffect(() => {
    setLinks([{ name: "Novo Cliente", to: "/clientes/novo" }]);
    setBtns([]);
    return () => { setLinks([]); setBtns([]); };
  }, [setLinks, setBtns]);

  return (
    <div className="list-group">
      {!loading && prospectos.length === 0 && (
        <p className="text-center text-muted">Nenhum prospecto encontrado.</p>
      )}
      <div>
        {prospectos.map((c) => (
          <ProspectoItem key={c.id} prospecto={c} carregarAcompanhamentos={carregarAcompanhamentos} />
        ))}
      </div>
      {loading && <p className="text-center"><Spinner animation="border" /></p>}
    </div>
  );
};

const Contatos = () => {
  const [query, setQuery] = useState('');
  const [contatos, setContatos] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const { setLinks, setBtns, crudAdmin } = useProvider();
  const { get, loading } = crudAdmin || {};
  const navigate = useNavigate();

  useEffect(() => {
    buscarContatos(true);
  }, [query]);

  const buscarContatos = async (novaConaulta = false, url = `/core/contatos/?ordering=-data_criacao&prospecto__isnull=true`) => {
    try {
      const response = await get(url, "prospeccao");
      if (response && response[0]?.results) {
        setContatos((prev) => novaConaulta ? [...response[0].results] : [...prev, ...response[0].results]);
        setNextUrl(response[0]?.next || null);
      } else {
        setContatos([]);
        setNextUrl(null);
      }
    } catch (err) {
      console.error("Erro ao buscar prospectos:", err);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading && nextUrl) buscarContatos(false, nextUrl);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, nextUrl]);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true, mirror: false });
  }, []);

  useEffect(() => {
    setLinks([{ name: "Novo Cliente", to: "/clientes/novo" }]);
    setBtns([]);
    return () => { setLinks([]); setBtns([]); };
  }, [setLinks, setBtns]);

  return (
    <div className="list-group">
      {!loading && contatos.length === 0 && (
        <p className="text-center text-muted">Nenhum contato encontrado.</p>
      )}
      <BotaoFlutuante to="/clientes/novo" icon="bi-plus" />
      <div>
        {contatos.map((c) => (
          <ProspectoItem key={c.id} prospecto={c} />
        ))}
      </div>
      {loading && <p className="text-center"><Spinner animation="border" /></p>}
    </div>
  );
};

const FormAcompanhar = ({ prospecto, setAcompanhamentos, onHide, setDados }) => {
  const [acompanhamento, setAcompanhamento] = useState({data: new Date().toLocaleString("sv-SE")});
  const [formErrors, setFormErrors] = useState({});
  const { crudAdmin } = useProvider();
  const { post, get, loading } = crudAdmin || {};

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const errors = {};
    if (!acompanhamento?.data || acompanhamento.data === "")
      errors.data = "Por favor, informe a data do acompanhamento.";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({});

    const formData = new FormData();
    formData.append("data", acompanhamento?.data);
    formData.append("prospecto", prospecto?.id);
    formData.append("observacoes", acompanhamento?.observacoes || ``);

    try {
      const response = await post(
        formData,
        `/rede/acompanhamentos/`,
        "multipart/form-data"
      );

      if (response && response.length) {
        const item = response[0];
        setAcompanhamentos((prev) => {
          if (!prev?.length) return prev; // não faz nada se estiver vazia
          const novaLista = [...prev, item];
          return novaLista.sort((a, b) => new Date(b.data) - new Date(a.data));
        });
        try{
          const prosp = await get(`/rede/prospectos/${item.prospecto}/`);
          if(prosp && prosp.length) setDados(prosp[0]);
        }catch(err){}
        if(onHide) onHide();
      }
    } catch (err) {
      if (err?.response?.detail) {
        setFormErrors(err.response.detail);
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} className="my-3">
        {formErrors.apiError && (
          <Alert variant="danger">{formErrors.apiError}</Alert>
        )}

        <Form.Group controlId={`formData_${prospecto?.id}`} className="mb-3">
          <InputGroup>
            <span className="input-group-text">Data</span>
            <Form.Control
              type="date"
              value={acompanhamento?.data || ""}
              onChange={(e) =>
                setAcompanhamento((prev) => ({
                  ...prev,
                  data: e.target.value,
                }))
              }
            />
          </InputGroup>
        </Form.Group>

        <Form.Group controlId={`formObservacoes_${prospecto?.id}`} className="mt-3">
          <Form.Control
            as="textarea"
            value={acompanhamento?.observacoes || ""}
            onChange={(e) =>
              setAcompanhamento((prev) => ({
                ...prev,
                observacoes: e.target.value,
              }))
            }
            placeholder="Observações"
            rows={5}
            style={{ resize: "none" }}
          />
        </Form.Group>

        <Button
          variant="secondary"
          type="submit"
          className="mt-4 w-100"
          disabled={loading}
        >
          Salvar
        </Button>
      </Form>
    </>
  );
};


const ModalAcompanhar = ({ show, onHide, prospecto, setAcompanhamentos, setDados}) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>Acompanhamento com {prospecto?.nome}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <FormAcompanhar prospecto={prospecto} setAcompanhamentos={setAcompanhamentos} onHide={onHide} setDados={setDados} />
    </Modal.Body>
  </Modal>
);

export default ProspectosBase;


